export default __webpack_public_path__ + "static/media/gm.be06b8b7.svg";